import React from "react";
import { ThemeModule } from "../../../modules/themes/theme.types";

export interface ThemeFooterProps {
  theme?: ThemeModule;
  relatedThemes?: ThemeModule[];
  relatedParcoursIds?: string[];
  relatedPlayIds?: string[];
  relatedAssistIds?: string[];
}

// Footer du theme : pour aller plus loin (placeholder simple).
export function ThemeFooter({ theme, relatedThemes, relatedParcoursIds }: ThemeFooterProps) {
  const isBiaisConfirmation = theme?.id === "biais-confirmation";
  return (
    <section className="rounded-2xl border shadow-sm p-5 bg-white dark:bg-slate-900 dark:border-slate-700 space-y-3">
      <h2 className="text-lg font-semibold">Pour aller plus loin</h2>
      {isBiaisConfirmation && (
        <p className="text-sm text-slate-700 dark:text-slate-200">
          Maintenant que tu vois comment ton esprit selectionne ce qui le rassure, tu peux choisir autre chose :
          aller chercher ce qui le bouscule. Ta curiosite devient ton meilleur outil contre le biais de confirmation.
        </p>
      )}
      {relatedThemes && relatedThemes.length > 0 ? (
        <ul className="list-disc list-inside text-sm text-slate-700 dark:text-slate-200 space-y-1">
          {relatedThemes.map((t) => (
            <li key={t.id}>{t.title}</li>
          ))}
        </ul>
      ) : (
        <div className="space-y-2 text-sm text-slate-600 dark:text-slate-300">
          {relatedParcoursIds && relatedParcoursIds.length > 0 && (
            <div>
              <p className="font-semibold">Parcours lies :</p>
              <ul className="list-disc list-inside">
                {relatedParcoursIds.map((pid) => (
                  <li key={pid}>
                    <a href={`/parcours/${pid}`} className="text-blue-600 underline">
                      Parcours guide
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )}
          <p>Suggestions a venir.</p>
          {/* TODO MixMind: lier des themes connexes et des parcours Play/Assist. */}
        </div>
      )}
    </section>
  );
}
